import { render, staticRenderFns } from "./RegistrationOpen.vue?vue&type=template&id=3b524dc5&scoped=true"
import script from "./RegistrationOpen.vue?vue&type=script&lang=js"
export * from "./RegistrationOpen.vue?vue&type=script&lang=js"
import style0 from "./RegistrationOpen.vue?vue&type=style&index=0&id=3b524dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b524dc5",
  null
  
)

export default component.exports